import { render, staticRenderFns } from "./facets-search.vue?vue&type=template&id=7c73bda7&"
import script from "./facets-search.ts?vue&type=script&lang=ts&"
export * from "./facets-search.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports